export default {
    debug: true,
    state: {
        editControlSource: {
            data: [],
            required: true
        },
        editControlMaxId: {
            data: NaN,
            required: true
        },
        editControlSelected: {
            data: null,
            required: true
        },
    },
    setEditControls: function (items) {
        const dataSource = []
        for (let i = 0; i < items.length; i++) {
            const item = items[i]
            dataSource.push({
                key: i,
                item: item,
                selected: false
            })
        }
        this.state.editControlSource.data = dataSource
        this.state.editControlMaxId.data = dataSource.length
    },
    getEditControls: function () {
        return this.state.editControlSource.data
    },
    addEditControl: function (audioItem) {
        const editControlMaxId = this.state.editControlMaxId.data
        this.state.editControlMaxId.data += 1

        const editControlSource = this.state.editControlSource.data
        editControlSource.push({
            key: editControlMaxId,
            item: audioItem,
            selected: false
        })
    },
    deleteEditControlItem: function (item) {
        const editControlSource = this.state.editControlSource.data
        const idx = editControlSource.indexOf(item)
        if (idx === -1) {
            return
        }
        editControlSource.splice(idx, 1)
    },
    toUpperEditControlOption: function (item) {
        const editControlSource = this.state.editControlSource.data
        const idx = editControlSource.indexOf(item)
        if (idx === -1) {
            return
        }

        if (idx === 0) {
            return
        }

        const upper = editControlSource[idx - 1]
        const lower = editControlSource[idx]
        editControlSource.splice(idx - 1, 2, lower, upper)
    },
    toLowerEditControlOption: function (item) {
        const editControlSource = this.state.editControlSource.data
        const idx = editControlSource.indexOf(item)
        if (idx === -1) {
            return
        }

        if (idx === editControlSource.length - 1) {
            return
        }

        const upper = editControlSource[idx]
        const lower = editControlSource[idx + 1]
        editControlSource.splice(idx, 2, lower, upper)
    },
    resetEditControlSelected: function () {
        this.state.editControlSelected.data = null
    },
    setEditControlSelected: function (option) {
        this.state.editControlSelected.data = option
        const dataSource = this.state.editControlSource.data
        for (let i = 0; i < dataSource.length; i++) {
            const data = dataSource[i]
            if (data === option) {
                data.selected = true
            } else {
                data.selected = false
            }
        }
    },
    getEditControlSelected: function () {
        return this.state.editControlSelected.data
    }

}
